import { useQuery } from '@apollo/client';

import { enqueueSnackbar } from 'notistack';

import { gql } from '../../generated';

const GET_ALL_CURRENCY = gql(/* GraphQL */ `
  query GetAllCurrency {
    currency {
      id
      icon
    }
  }
`);

const GET_MERCHANT_CURRENCY = gql(/* GraphQL */ `
  query GetMerchantCurrency {
    merchant_currency(order_by: { currency: { id: asc } }) {
      currency {
        id
        icon
      }
    }
  }
`);

export const useCurrency = (availableCurrency?: boolean, noAuth?: boolean) => {
  const { loading: allLoading, data: allData } = useQuery(GET_ALL_CURRENCY, {
    skip: availableCurrency,
    context: {
      noAuth,
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  });

  const { loading: merchantLoading, data: merchantData } = useQuery(GET_MERCHANT_CURRENCY, {
    skip: !availableCurrency,
    context: {
      noAuth,
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  });

  if (availableCurrency) {
    return {
      loading: merchantLoading,
      data: merchantData?.merchant_currency.map(({ currency }) => currency),
    };
  }

  return {
    loading: allLoading,
    data: allData?.currency,
  };
};
